<script>
import { InboundShipment, Product } from "@/services/westore/entities";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import Faqs from "../../../components/faqs.vue";
import FormSkeleton from "../../../components/skeletons/form-skeleton.vue";
import vue2Dropzone from "vue2-dropzone";
import { Download } from "@/mixins/download";
import StepIcon from "../../../customIcons/stepIcon.vue";
import Modal from "../../../components/modal.vue";

export default {
  mixins: [Download],
  page: {
    title: "Create Inbound Shipment",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Faqs,
    FormSkeleton,
    vueDropzone: vue2Dropzone,
    StepIcon,
    Modal,
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 500,
        maxFilesize: 15,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFile: "Remove",
        previewTemplate: this.template(),
        uploadMultiple: false,
        maxfilesexceeded(file) {
          this.removeFile(file);
        },
      },
      errors: [],
      inboundErrors: [],
      stepper: 1,
      title: "New Inbound",
      subtitle: "Please fill all the mandatory fields.",
      submitted: false,
      loader: false,
      isSuccess: false,
      successMessage: "",
      receivingTimes: [],
      showContentLoader: true,
      fileUploaded: false,
      minDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 1
      ),
      faqs: [
        { question: "Question 1", answer: "Answer Answer" },
        {
          question: "How long would it take for the order to be executed?",
          answer:
            "To enable automatic updates for Admin Columns Pro, enter your license key. If you don't have a license key, please see details & pricing.",
        },
      ],
      expandForm: false,
      formData: new FormData(),
      form: {
        receivingDate: null,
        receivingTime: null,
      },
      hasProducts: false,
      openImportModal: false,
      file: null,
    };
  },
  validations: {
    form: {
      receivingDate: { required },
      receivingTime: { required },
    },
  },
  created() {
    this.fetchOptions().then(() => this.init());
  },

  computed: {
    checkLoader() {
      return this.loader;
    },
    isInboundReady() {
      return (
        this.file &&
        this.form.receivingDate &&
        // (this.form.receivingTime || this.form.receivingTime == 0) &&
        this.hasProducts
      );
    },
  },
  methods: {
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                    <div class="dz-size"><span data-dz-size></span></div>
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-plus"></i></div>
            </div>
        `;
    },
    async downloadInboundTemplate() {
      let data = await InboundShipment.blobResponse().getTemplate();
      const type = InboundShipment.getHeader("content-type");
      const filename = `inbound_${new Date().getTime()}.xlsx`;
      this.download(data, type, filename);
    },
    async downloadProductTemplate() {
      let data = await Product.blobResponse().getTemplate();
      const type = Product.getHeader("content-type");
      const filename = `products_${new Date().getTime()}.xlsx`;
      this.download(data, type, filename);
    },
    init() {
      // this.form.receivingTime = this.receivingTimes[0].value;
      this.showContentLoader = false;
    },
    async submitInbound() {
      this.submitted = true;

      this.loader = true;
      this.formData.append("source_sheet", this.file);
      this.formData.append("receiving_date", this.form.receivingDate);
      this.formData.append("receiving_time", this.form.receivingTime + 1);
      this.$refs.customDropzone.processQueue();
      try {
        await InboundShipment.store(this.formData).then((res) => {
          this.reset();
          this.$toast.success("Inbound Shipment has been created successfully");
          setTimeout(
            () =>
              this.$router.push({
                name: "inbound-shipment-details",
                params: { id: res.data.data.id },
              }),
            1000
          );
        });
      } catch ({ response }) {
        console.log("response", response);
        if (response.data.errors) {
          this.$toast.error(response.data.message);
        }
        if (response.data.errors) {
          this.inboundErrors = response.data.errors;
        }
      } finally {
        this.submitted = false;
        this.loader = false;
      }
    },

    reset() {
      this.$v.$reset();
      this.submitted = false;
      this.showContentLoader = false;
      this.form = {
        receivingDate: null,
        receivingTime: null,
      };
    },
    async fetchOptions() {
      const { data: options } = await InboundShipment.getOptions();
      this.receivingTimes = options.receiving_times;
      this.hasProducts = options.has_products;
      return Promise.resolve();
    },
    toggleFormListener(val) {
      this.expandForm = val;
    },
    closeModal() {
      this.openImportModal = false;
    },
    getStepStatus(step) {
      if (step === 1) {
        return this.hasProducts ? "done" : "active";
      }
      if (step === 2) {
        return this.hasProducts &&
          (this.form.receivingTime || this.form.receivingTime == 0) &&
          this.form.receivingDate
          ? "done"
          : this.hasProducts
          ? "active"
          : "";
      }
      if (step === 3) {
        return this.hasProducts &&
          (this.form.receivingTime || this.form.receivingTime == 0) &&
          this.form.receivingDate &&
          this.file
          ? "done"
          : this.hasProducts &&
            (this.form.receivingTime || this.form.receivingTime == 0) &&
            this.form.receivingDate
          ? "active"
          : "";
      }
    },
    async uploadProductCatalog(file) {
      let data = new FormData();
      data.append("file", file);
      try {
        let { data: resData } = await Product.uploadProducts(data);
        if (resData.status === "success") {
          this.closeModal();
          this.$toast.success("Your products has been uploaded successfully");
          this.hasProducts = true;
          this.fileUploaded = true;
        } else if (resData.status === "error") {
          this.errors = resData.message;
          this.$toast.error("There are mismatches in your file,");
        }
      } catch ({ response }) {
        this.$toast.error(response.data?.message);
      }
    },
    fileAdded(file) {
      this.file = file;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :subtitle="subtitle" />
    <div class="row d-flex flex-row">
      <div
        class="col-md-9 col-sm-12 order-2 order-sm-12"
        :class="expandForm && 'col-md-11 col-sm-12'"
      >
        <div class="card">
          <FormSkeleton v-if="showContentLoader" />
          <div class="card-body" v-else>
            <div class="card-header">
              <div class="text-info fw-smibold font-size-18">
                Create new inbound
              </div>
              <div class="d-flex align-center font-size-14 mt-5">
                <v-icon size="18"> $vuetify.icons.exclamation </v-icon
                ><span class="mx-1 text-danger">#Note: </span
                ><span> Upload only SKU that:</span>
              </div>
              <div class="ml-16">
                <div>&bull; DOES NOT already exist in your catalog</div>
                <div>
                  &bull; DOES exist in your catalog, but you want to make
                  changes to it
                </div>
              </div>
            </div>
            <div class="card-header">
              <!-- step 1 -->
              <div>
                <div class="d-flex align-center">
                  <StepIcon
                    :status="getStepStatus(1)"
                    class="mr-4 font-weight-bold"
                  />
                  <span class="font-size-16 text-primary">Step 1:</span>
                  <span class="text-grey font-size-14 ml-2"
                    >Upload your catalog</span
                  >
                </div>
              </div>
              <div v-if="fileUploaded" class="d-flex align-center mt-6 ml-11">
                <div
                  class="grow custom-shadow d-flex align-center justify-space-between rounded-3 p-2"
                >
                  <span class="text-primary font-size-16 bold"
                    >Your Catalog</span
                  >
                  <div class="d-flex align-center">
                    <span class="text-capitalize text-success font-size-14"
                      >uploaded</span
                    >
                    <v-icon size="16" class="ml-2">
                      $vuetify.icons.check</v-icon
                    >
                  </div>
                </div>
                <a
                  class="text-capitalize text-info font-size-14 text-decoration-underline ml-4"
                  @click.prevent="openImportModal = true"
                  >Reupload</a
                >
              </div>
              <div
                v-else
                class="custom-shadow d-flex align-center justify-space-between rounded-3 p-2 mt-6 ml-11"
              >
                <span class="text-primary font-size-16 bold">Your Catalog</span>
                <v-btn color="info" outlined @click="openImportModal = true"
                  ><span class="text-capitalize">upload</span></v-btn
                >
              </div>
            </div>
            <div class="card-header">
              <!-- step 2 -->
              <div>
                <div class="d-flex align-center">
                  <StepIcon
                    :status="getStepStatus(2)"
                    class="mr-4 font-weight-bold"
                  />
                  <span class="font-size-16 text-primary">Step 2:</span>
                  <span class="text-grey font-size-14 ml-2"
                    >Receiving date and time </span
                  ><br />
                </div>
                <div class="ml-12 mt-1">
                  <span
                    >Kindly select the shipment’s expected receiving time and
                    date</span
                  >
                  <b-row class="d-flex flex-wrap">
                    <!--Calendar-->
                    <b-col
                      label="Receiving Date*"
                      col
                      lg="6"
                      md="12"
                      class="mb-3"
                      label-size="lg"
                    >
                      <b-form-group
                        class="mb-3 form-label"
                        :label="$t('Receiving Date*')"
                        label-size="lg"
                        label-for="receiving-date-input"
                      >
                        <b-calendar
                          class="calendar-border rounded p-2"
                          :min="minDate"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit',
                            weekday: 'short',
                          }"
                          locale="en-US"
                          v-model="form.receivingDate"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.receivingDate.$error,
                          }"
                          id="receiving-date-input"
                        ></b-calendar>
                      </b-form-group>
                    </b-col>

                    <!--ReceivingTime-->
                    <!-- <b-col lg="6" md="12">
                      <b-form-group
                        class="mb-3 form-label"
                        :label="$t('Receiving Time*')"
                        label-size="lg"
                        label-for="receiving-time-input"
                      >
                        <b-tabs
                          pills
                          v-model="form.receivingTime"
                          id="receiving-time-input"
                          content-class="mt-3 pl-0"
                        >
                          <b-tab
                            class="text-start"
                            v-for="{ text, value } in receivingTimes"
                            :title="text"
                            :key="value"
                          >
                          </b-tab>
                        </b-tabs>
                      </b-form-group>
                    </b-col> -->
                  </b-row>
                </div>
              </div>
            </div>
            <div class="card-header">
              <!-- step 3 -->
              <div>
                <div class="d-flex align-center">
                  <StepIcon
                    :status="getStepStatus(3)"
                    class="mr-4 font-weight-bold"
                  />
                  <span class="font-size-16 text-primary">Step 3:</span>
                  <span class="text-grey font-size-14 ml-2"
                    >Inbound shipment details</span
                  >
                </div>
              </div>

              <div class="card mb-0 ml-12 mt-1">
                <div class="card-body p-0">
                  <div class="card-title-desc">
                    <a
                      class="text-info text-decoration-underline"
                      @click="downloadInboundTemplate"
                      >{{ $t("Download the template") }}</a
                    >
                    {{ $t("and fill out the required fields.") }}<br />
                    <div class="my-2">
                      <v-icon color="gray" size="20"
                        >$vuetify.icons.info</v-icon
                      >
                      <span
                        :class="
                          isRtl
                            ? 'card-title-desc mr-1'
                            : 'card-title-desc ml-1'
                        "
                        >{{ $t("Note: You can upload up to 1000 SKUS") }}</span
                      >
                    </div>
                    <div class="my-2">
                      <v-icon color="gray" size="20"
                        >$vuetify.icons.info</v-icon
                      >
                      <span
                        :class="
                          isRtl
                            ? 'card-title-desc mr-1'
                            : 'card-title-desc ml-1'
                        "
                        >{{ $t("Note: File type must be xlsx") }}</span
                      >
                    </div>
                    <div class="my-2">
                      <v-icon color="gray" size="20"
                        >$vuetify.icons.info</v-icon
                      >
                      <span
                        :class="
                          isRtl
                            ? 'card-title-desc mr-1'
                            : 'card-title-desc ml-1'
                        "
                        >{{
                          $t(
                            "Note: Upload only SKUs that already exist in your catalog"
                          )
                        }}</span
                      >
                    </div>
                  </div>

                  <div
                    v-if="inboundErrors.length > 0"
                    class="d-flex flex-column align-items-center mb-2"
                  >
                    <v-icon color="primary" size="25"
                      >$vuetify.icons.error</v-icon
                    >
                    <div class="flex-grow-1 align-self-center mt-2">
                      <h4 class="card-subtitle text-center">
                        Unable to import Inbound
                      </h4>
                    </div>
                  </div>
                  <p
                    v-if="inboundErrors.length > 0"
                    class="card-title text-center mb-1"
                  >
                    To import these Inbound, please make the following changes:
                  </p>
                  <!-- file upload -->
                  <div v-if="inboundErrors.length > 0" class="mb-5 text-center">
                    <div
                      class="text-danger"
                      v-for="(error, index) in inboundErrors"
                      :key="index"
                    >
                      {{ error[0] }}
                    </div>
                  </div>

                  <vue-dropzone
                    ref="customDropzone"
                    id="inboundDropzone"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="fileAdded"
                    @vdropzone-removed-file="file = null"
                  ></vue-dropzone>
                </div>
                <!-- end card-body -->
              </div>
              <!-- Submit -->

              <div class="d-flex justify-end mt-9">
                <v-progress-circular
                  v-if="checkLoader"
                  :size="30"
                  color="secondary"
                  indeterminate
                ></v-progress-circular>
                <b-button
                  v-else
                  :disabled="!isInboundReady"
                  @click="submitInbound"
                  variant="primary"
                  class="btn-block"
                >
                  {{ $t("Submit inbound") }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="order-1 order-sm-12"
        :class="
          expandForm
            ? 'col-md-1 col-sm-12 d-flex justify-content-end'
            : 'col-md-3 col-sm-12'
        "
      >
        <Faqs :faqs="faqs" title="Inbound" @toggleForm="toggleFormListener">
          <v-expansion-panels>
            <v-expansion-panel class="panel">
              <v-expansion-panel-header class="panel__header">
                Question 1
                <template v-slot:actions>
                  <v-icon color="pink"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="panel__content opacity-75">
                Answer Answer
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="panel">
              <v-expansion-panel-header class="panel__header">
                How long would it take for the order to be executed?
                <template v-slot:actions>
                  <v-icon color="pink"> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="panel__content opacity-75">
                To enable automatic updates for Admin Columns Pro, enter your
                license key. If you don't have a license key, please see details
                & pricing.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </Faqs>
      </div>
    </div>
    <Modal
      :dialog="openImportModal"
      :closeModal="closeModal"
      :uploadSuccess="uploadProductCatalog"
      :modalTitle="'Product Catalog'"
      :modalNote="'We support up to 1000 products per upload. - File type must be xslx'"
      :errors="errors"
    >
      <template>
        <div class="text-center my-5 d-flex px-2">
          <a
            class="text-info border border-info p-2 rounded-2 fw-bold mr-3 flex-grow-1"
            @click="downloadProductTemplate"
          >
            {{ $t("Download the template") }}
            <v-icon :class="isRtl ? 'mr-2' : 'ml-2'" size="20"
              >$vuetify.icons.download</v-icon
            >
          </a>
        </div>
      </template>
    </Modal>
  </Layout>
</template>

<style lang="scss">
@media screen and (max-width: 992px) {
  .v-stepper__content {
    margin: 0 !important;
    padding: 0 !important;
  }
}
.v-stepper__wrapper {
  height: auto !important;
}

.v-stepper__step__step,
.v-stepper__step__step.primary {
  background-color: #cecdcd !important;
  border-color: #cecdcd !important;
}
.nav-pills .nav-link {
  background: #e0e0e0;
  border-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 7px;
  min-width: 215px;
  text-align: center;
  font-weight: 700;
  margin-right: 5px;
}

.v-sheet.v-stepper:not(.v-sheet--outlined) {
  box-shadow: none;
}

.b-calendar-header > output {
  color: #101820;
}
.b-calendar-grid-caption {
  margin-bottom: 12px;
  margin-top: 2px;
  color: #101820;
}
.v-stepper__label,
.v-stepper__step__step {
  cursor: pointer;
}
.b-calendar-inner {
  width: 100% !important;
  .rounded-circle {
    width: 30px;
    height: 30px;
    line-height: 30px;
    padding: 0;
  }
}

.calendar-border {
  border: 1px solid #ced4da;

  footer {
    display: none;
  }
}

.shipment-manifest-file {
  border-radius: 4px;
  border: 1px dashed var(--v-primary-base);
  padding: 10px;

  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse";
  }

  .preview {
    display: inline-block;
    border-radius: 5px;
    border: 1px solid var(--v-primary-base);
    margin: 3px;
  }
}

.shipment-manifest-file.is-invalid {
  border-color: var(--v-error-base);
}

.vue-dropzone {
  border: 2px solid #e5e5e5;
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: 0.2s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 150px !important;
}
.vue-dropzone:hover {
  background-color: #f6f6f6;
}
.vue-dropzone > i {
  color: #ccc;
}
.vue-dropzone > .dz-preview {
  width: 75%;
  display: flex;
  justify-content: center;
}
.dropzone {
  border-color: var(--v-info-base) !important;
}
.dropzone .dz-preview .dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 16px;
  left: unset;
  top: 50%;
  margin-top: -8px;
  width: 60%;
  margin-left: 0;
  background: rgba(255, 255, 255, 0.9);
  -webkit-transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}
.vue-dropzone > .dz-preview .dz-image {
  border-radius: 0;
  width: 100% !important;
  height: 100%;
}
.vue-dropzone > .dz-preview .dz-image img:not([src]) {
  width: 200px;
  height: 200px;
}
.vue-dropzone > .dz-preview .dz-image:hover img {
  transform: none;
  -webkit-filter: none;
}
.vue-dropzone > .dz-preview .dz-details {
  bottom: 0;
  top: 0;
  color: white;
  background-color: rgba(33, 150, 243, 0.8);
  transition: opacity 0.2s linear;
  text-align: left;
  background-color: var(--v-primary-base) !important;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename {
  overflow: hidden;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename span,
.vue-dropzone > .dz-preview .dz-details .dz-size span {
  color: white;
  background-color: transparent;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: none;
  margin-top: 15px;
  display: inline-block;
}
.vue-dropzone > .dz-preview .dz-details .dz-filename:hover span {
  background-color: transparent;
  border: none;
}
.vue-dropzone > .dz-preview .dz-progress .dz-upload {
  background: var(--v-info-base);
}
.vue-dropzone > .dz-preview .dz-remove {
  position: absolute;
  z-index: 3000;
  color: white;
  margin-left: 15px;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.1px;
  background-color: var(--v-secondary-base);
  border-radius: 5px;
  opacity: 0;
}
.vue-dropzone > .dz-preview:hover .dz-remove {
  opacity: 1;
}

.vue-dropzone > .dz-preview .dz-success-mark,
.vue-dropzone > .dz-preview .dz-error-mark {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  top: 35%;
  left: 42.5%;

  font-size: 200%;
  border-radius: 50%;
}
.vue-dropzone > .dz-preview .dz-success-mark {
  color: #fff !important;
  background-color: var(--v-success-base) !important;
}
.vue-dropzone > .dz-preview .dz-error-mark {
  color: white !important;
  background-color: var(--v-secondary-base) !important;
}
.vue-dropzone > .dz-preview .dz-error-mark i {
  -webkit-transform: rotate(45deg) !important;
  transform: rotate(45deg) !important;
}
.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
}
.vue-dropzone > .dz-preview .dz-success-mark svg,
.vue-dropzone > .dz-preview .dz-error-mark svg {
  margin-left: auto;
  margin-right: auto;
}
.vue-dropzone > .dz-preview .dz-error-message {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  width: 100%;
  text-align: center;
}
.vue-dropzone > .dz-preview .dz-error-message:after {
  display: block;
}
.custom-shadow {
  box-shadow: 0px 2px 16px rgba(16, 24, 32, 0.12);
}

.card-header {
  background-color: #fff;
}
</style>
